const PUFFS = [
  { l: "-10%", t: "10%", s: 70, d: 46, delay: 0 },
  { l: "55%", t: "-5%", s: 60, d: 58, delay: -12 },
  { l: "20%", t: "55%", s: 80, d: 64, delay: -24 },
  { l: "70%", t: "60%", s: 65, d: 52, delay: -36 },
  { l: "-5%", t: "80%", s: 55, d: 60, delay: -8 },
];

export const Smoke = () => (
  <div className="smoke-layer" aria-hidden="true">
    {PUFFS.map((p, i) => (
      <span key={i} className="smoke-puff"
        style={{ left: p.l, top: p.t, width: `${p.s}vmax`, height: `${p.s * 0.6}vmax`, animationDuration: `${p.d}s`, animationDelay: `${p.delay}s` }} />
    ))}
  </div>
);
